const enableRailDrag = (rail) => {
  let startX = 0;
  let startScroll = 0;
  let isPressed = false;
  let hasMoved = false;

  rail.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    isPressed = true;
    hasMoved = false;
    startX = event.clientX;
    startScroll = rail.scrollLeft;
  });

  rail.addEventListener('pointermove', (event) => {
    if (!isPressed) return;
    const distance = event.clientX - startX;

    if (!hasMoved) {
      if (Math.abs(distance) < 5) return;
      hasMoved = true;
      rail.classList.add('is-dragging');
      rail.setPointerCapture(event.pointerId);
    }

    rail.scrollLeft = startScroll - distance;
  });

  const release = () => {
    if (!isPressed) return;
    isPressed = false;
    if (hasMoved) requestAnimationFrame(() => rail.classList.remove('is-dragging'));
  };

  rail.addEventListener('pointerup', release);
  rail.addEventListener('pointercancel', release);
  rail.addEventListener('dragstart', (event) => event.preventDefault());
  rail.addEventListener(
    'click',
    (event) => {
      if (!hasMoved) return;
      event.preventDefault();
      event.stopPropagation();
      hasMoved = false;
    },
    true
  );
};

if (!customElements.get('cs-tabs')) {
  customElements.define(
    'cs-tabs',
    class CsTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.querySelectorAll('.cs-rail').forEach(enableRailDrag);
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const isSelected = i === index;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.tabIndex = isSelected ? 0 : -1;
        });

        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });
      }

      onKeydown(event, index) {
        const keys = { ArrowRight: 1, ArrowLeft: -1 };
        if (!(event.key in keys)) return;

        event.preventDefault();
        const next = (index + keys[event.key] + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      }
    }
  );
}
